import axiosLib from "axios";

const api = axiosLib.create({
  baseURL: `${process.env.API_URL || ""}/api`,
  headers: { "Content-Type": "application/json" },
});

export function extractErrorMessage(error: unknown): string {
  if (axiosLib.isAxiosError(error)) {
    return (
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message
    );
  }
  return String(error);
}

export default api;
